export const environment = {
    url: "https://yagami.splitpaybrasil.dev.br/api",
    nami_url: "https://nami.splitpaybrasil.dev.br/api",
    nami_job_url: "https://nami.splitpaybrasil.dev.br",
    enma_url: "https://api.splitpaybrasil.dev.br/api",
    url_mercure: "https://mercure.splitpaybrasil.dev.br"
};
